export default function toString(x) {
  return x && x.toString();
}